export default {
  // Common
  "appName": "Qonso",
  "loading": "Cargando...",
  "error": "Se produjo un error",
  "success": "Éxito",
  "save": "Guardar",
  "cancel": "Cancelar",
  "confirm": "Confirmar",
  "back": "Atrás",
  "backToHome": "Volver al inicio",
  "backToLogin": "Volver al inicio de sesión",
  "backToForgotPassword": "Volver a olvidé mi contraseña",
  "next": "Siguiente",
  "submit": "Enviar",
  "delete": "Eliminar",
  "edit": "Editar",
  "view": "Ver",
  "close": "Cerrar",
  "and": "y",
  "pleaseWait": "Por favor espere...",
  "verifyingLink": "Verificando su enlace",
  
  // Auth
  "login": "Iniciar sesión",
  "register": "Registrarse",
  "forgotPassword": "Olvidé mi contraseña",
  "resetPassword": "Restablecer contraseña",
  "email": "Correo electrónico",
  "password": "Contraseña",
  "confirmPassword": "Confirmar contraseña",
  "fullName": "Nombre completo",
  "age": "Edad",
  "country": "País",
  "signIn": "Iniciar sesión",
  "signUp": "Registrarse",
  "signOut": "Cerrar sesión",
  "createAccount": "Crear cuenta",
  "creatingAccount": "Creando cuenta...",
  "signingIn": "Iniciando sesión...",
  "signInToTrack": "Inicia sesión para seguir tu hidratación",
  "joinQonsoToday": "¡Únete a Qonso hoy y comienza tu viaje de hidratación!",
  "alreadyHaveAccount": "¿Ya tienes una cuenta?",
  "dontHaveAccount": "¿No tienes una cuenta?",
  "rememberPassword": "¿Recuerdas tu contraseña?",
  "forgotPasswordQuestion": "¿Olvidaste tu contraseña?",
  "resetPasswordInstructions": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
  "sendResetLink": "Enviar enlace",
  "sending": "Enviando...",
  "passwordResetSent": "Se ha enviado un enlace de restablecimiento a tu correo electrónico. Por favor, revisa tu bandeja de entrada y sigue las instrucciones.",
  "passwordUpdated": "Contraseña actualizada con éxito",
  "passwordsDoNotMatch": "Las contraseñas no coinciden",
  "passwordMinLength": "La contraseña debe tener al menos 6 caracteres",
  "emailRequired": "El correo electrónico es obligatorio",
  "passwordRequired": "La contraseña es obligatoria",
  "fullNameRequired": "El nombre completo es obligatorio",
  "ageRequired": "La edad es obligatoria",
  "countryRequired": "El país es obligatorio",
  "acceptTerms": "Acepto los",
  "termsRequired": "Debes aceptar los términos para continuar",
  "emailConfirmationRequired": "Por favor, verifica tu correo electrónico para confirmar tu cuenta",
  "emailConfirmationSent": "Se ha enviado un correo de confirmación a tu dirección. Por favor, revisa tu bandeja de entrada y sigue las instrucciones para completar tu registro.",
  "emailConfirmationSuccess": "¡Tu correo electrónico ha sido confirmado con éxito!",
  "emailConfirmationFailed": "La confirmación del correo electrónico falló",
  "emailConfirmed": "Correo Electrónico Confirmado",
  "emailVerifiedRedirect": "Tu correo electrónico ha sido verificado. Serás redirigido al panel de control.",
  "confirmingEmail": "Confirmando tu correo electrónico",
  "pleaseWaitVerifying": "Por favor, espera mientras verificamos tu correo electrónico...",
  "invalidConfirmationLink": "Enlace de confirmación inválido",
  "failedToConfirmEmail": "Error al confirmar el correo electrónico",
  "goToDashboard": "Ir al panel de control",
  "selectCountry": "Seleccione un país",
  "selectCountries": "Seleccionar países",
  "leaveEmptyForAllCountries": "Dejar vacío para hacer disponible en todos los países",
  "targetCountries": "Países objetivo",
  "allCountries": "Todos los países",
  "pleaseAllFields": "Por favor complete todos los campos",
  "loginFailed": "Correo electrónico o contraseña incorrectos. Por favor, inténtalo de nuevo.",
  "registrationFailed": "El registro falló. Por favor, inténtalo de nuevo.",
  "emailAlreadyRegistered": "Este correo electrónico ya está registrado",
  "invalidEmail": "Por favor, ingresa un correo electrónico válido",
  "invalidAge": "Por favor, ingresa una edad válida",
  "invalidPassword": "Formato de contraseña inválido",
  "currentPassword": "Contraseña actual",
  "newPassword": "Nueva contraseña",
  "confirmNewPassword": "Confirmar nueva contraseña",
  "updating": "Actualizando...",
  "emailCannotBeChanged": "El correo electrónico no puede ser modificado",
  "tooManyAttempts": "Demasiados intentos. Por favor, inténtalo de nuevo en unos minutos.",
  "sessionExpired": "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
  "networkError": "Error de red. Por favor, verifica tu conexión e inténtalo de nuevo.",
  "unknownError": "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.",
  "checkYourEmail": "Revisa tu correo electrónico",
  "didntReceiveEmail": "¿No recibiste el correo?",
  "resendEmail": "Reenviar correo",
  "emailConfirmedInstructions": "Tu correo electrónico ha sido confirmado con éxito. Ahora puedes iniciar sesión en tu cuenta.",
  "proceedToLogin": "Continuar al inicio de sesión",
  "passwordResetInstructions": "Le enviaremos un enlace por correo eletrónico para restablecer su contraseña.",
  "resetLinkSent": "Se ha enviado un nuevo enlace de restablecimiento",
  "resetLinkFailed": "Error al enviar el enlace de restablecimiento",
  "emailVerificationInstructions": "Recibirá un link por correo electrónico para confirmar su inscripción.",
  "setNewPassword": "Establecer nueva contraseña",
  "createNewPassword": "Crea una nueva contraseña para tu cuenta",
  "passwordResetComplete": "Tu contraseña ha sido restablecida. Ahora puedes usar tu nueva contraseña para acceder a tu cuenta.",
  "passwordUpdateFailed": "Error al actualizar la contraseña. Por favor, inténtalo de nuevo.",
  "invalidResetLink": "Enlace de restablecimiento inválido o expirado",
  "errorResendingEmail": "Error al reenviar el correo de verificación. Por favor, inténtalo de nuevo más tarde.",

  // Admin
  "adminLogin": "Inicio de Sesión de Administrador",
  "adminLoginDescription": "Inicia sesión para acceder al panel de administración",
  
  // Home
  "mainTitle": "¡Hidrátate, Acumula, Gana! 💧",
  "mainTitleHighlight": "Con Qonso, gana premios por beber agua",
  "homeDescription": "Qonso te ayuda a mantenerte hidratado mientras te premia por tus buenos hábitos. Bebe agua, gana puntos y cámbialos por regalos.",
  "getStarted": "Comenzar",
  "features": "Características",
  "whyUseQonso": "¿Por qué usar Qonso?",
  "featuresDescription": "Descubre cómo Qonso te ayuda a mantener hábitos saludables de hidratación mientras lo hace divertido y gratificante.",
  "trackHydration": "Seguimiento de hidratación",
  "trackHydrationDescription": "Registra tu consumo diario de agua y monitorea tu progreso con nuestro sistema fácil de usar.",
  "dailyGoals": "Objetivos diarios",
  "dailyGoalsDescription": "Qonso te anima a alcanzar un objetivo diario de 2,5 L de agua.",
  "participateSurveys": "Participa en encuestas",
  "participateSurveysDescription": "Gana más puntos participando en nuestras diferentes encuestas.",
  "redeemRewards": "Canjea recompensas",
  "redeemRewardsDescription": "Convierte tus puntos ganados en recompensas y ofertas especiales.",
  
  // Benefits section
  "benefitsOfHydration": "Beneficios de mantenerse hidratado",
  "benefitsDescription": "Una hidratación adecuada es esencial para tu salud y bienestar. Aquí te explicamos por qué deberías controlar tu consumo de agua con Qonso.",
  "improvedEnergyLevels": "Mejora de los niveles de energía",
  "improvedEnergyDescription": "Mantenerse hidratado ayuda a mantener tus niveles de energía durante todo el día, reduciendo la fatiga y mejorando la concentración.",
  "betterPhysicalPerformance": "Mejor rendimiento físico",
  "betterPhysicalDescription": "La hidratación adecuada mejora el rendimiento físico durante el ejercicio y las actividades diarias.",
  "enhancedCognition": "Función cognitiva mejorada",
  "enhancedCognitionDescription": "El agua ayuda a que tu cerebro funcione de manera óptima, mejorando la concentración y la memoria.",
  "healthierSkin": "Piel más saludable",
  "healthierSkinDescription": "Mantenerse hidratado ayuda a mantener la elasticidad de la piel y promueve un cutis más saludable y radiante.",
  "improvedDigestion": "Mejora de la digestión",
  "improvedDigestionDescription": "El agua es esencial para una digestión adecuada y ayuda a prevenir el estreñimiento.",
  "joinCommunity": "Únete a nuestra comunidad",
  "joinCommunityDescription": "Conéctate con miles de usuarios que están mejorando sus hábitos de hidratación con Qonso.",
  
  // Testimonials
  "userTestimonials": "Lo que dicen nuestros usuarios",
  "testimonialsDescription": "Únete a miles de usuarios satisfechos que han mejorado sus hábitos de hidratación con Qonso.",
  "testimonial1": "Qonso ha cambiado completamente la forma en que controlo mi consumo de agua. ¡El sistema de recompensas me mantiene motivada!",
  "testimonialRole1": "Entusiasta del fitness",
  "testimonial2": "Nunca me di cuenta de lo poca agua que bebía hasta que comencé a usar Qonso. Ahora estoy correctamente hidratado todos los días.",
  "testimonialRole2": "Trabajador de oficina",
  "testimonial3": "Las encuestas y recompensas hacen que mantenerse hidratado sea divertido. ¡Ya he canjeado varias recompensas!",
  "testimonialRole3": "Estudiante",
  
  // CTA
  "ctaHeading": "¿Listo para comenzar tu viaje de hidratación?",
  "ctaDescription": "Únete a Qonso hoy y transforma tus hábitos de hidratación mientras ganas emocionantes recompensas.",
  
  // Dashboard
  "welcomeBack": "Buenos días",
  "hydrationTracking": "Valide su consumo de agua para ganar puntos",
  "dailyGoal": "Objetivo diario",
  "streak": "Racha",
  "points": "Puntos",
  "daysInARow": "Días consecutivos",
  "totalEarned": "Total de puntos ganados",
  "validateConsumption": "💧Registrar Tu Consumo De Agua",
  "dailyLimitReached": "Límite diario alcanzado",
  "limitReached": "¡Límite diario alcanzado!",
  "comeBackTomorrow": "¡Bien Hecho! Has Registrado Tu Consumo De Hoy. ¿Nos Vemos Mañana? 😉",
  "waterType": "Tipo de agua",
  "plainWater": "Agua natural",
  "plainWaterDesc": "Agua regular",
  "mineralWater": "Agua mineral",
  "mineralWaterDesc": "Agua mineral natural",
  "sparklingWater": "Agua con gas",
  "sparklingWaterDesc": "Agua carbonatada",
  "flavoredWater": "Agua saborizada",
  "flavoredWaterDesc": "Agua con sabores naturales",
  "uploadPhoto": "Haga una foto de su vaso o botella de agua",
  "photoSelected": "Foto seleccionada",
  "photoRequired": "Por favor tome una foto de su agua",
  "fixedAmount": "Volumen de agua", 
  "streak": "Racha",
  "days": "d",
  "points": "Puntos",
  "time": "Hora",
  "weeklyProgress": "7 Días",
  "total": "Total",
  "goals": "Objetivos",
  "dailyProgress": "Progreso",
  "consumptionValidated": "Consumo validado",
  "validate": "Validar",
  "validating": "Validación en curso",
  "totalWaterConsumed": "Agua Total Consumida",
  "lifetimeConsumption": "Consumo total",
  "ofDailyGoals": "de objetivos diarios",
  "showWeeklyStats": "Mostrar estadísticas semanales",
  "hideWeeklyStats": "Ocultar estadísticas semanales",
  "weeklyProgress": "Progreso semanal",
  "sunday": "Dom",
  "monday": "Lun",
  "tuesday": "Mar",
  "wednesday": "Mié",
  "thursday": "Jue",
  "friday": "Vie",
  "saturday": "Sáb",
  "lastWeek": "Semana pasada",
  "today": "Hoy",
  "insights": "Información",
  "lifetimeAchievement": "Has consumido un total de",
  "ofWater": "de agua desde que comenzaste",
  "startTrackingToday": "¡Comienza a registrar tu consumo de agua hoy!",
  "keepUpStreak": "¡Mantén tu racha de {{streak}} días!",
  "startStreak": "¡Comienza tu racha hoy!",
  
  // Rewards
  "rewards": "Recompensas",
  "rewardsCatalog": "Catálogo de recompensas",
  "rewardHistory": "Historial de recompensas",
  "rechargeCard": "Tarjeta de recarga",
  "giftCard": "Tarjeta de regalo",
  "request": "Solicitar",
  "requestReward": "Solicitar recompensa",
  "notEnoughPoints": "Puntos insuficientes",
  "rewardRequested": "Recompensa solicitada con éxito",
  "errorRequestingReward": "Error al solicitar recompensa",
  "reward": "Recompensa",
  "status": "Estado",
  "pending": "Pendiente",
  "approved": "Aprobado",
  "rejected": "Rechazado",
  "requestDate": "Fecha de solicitud",
  "noRewardRequests": "No hay solicitudes de recompensa",
  "yourPoints": "Puntos",
  "noRewards": "No hay recompensa disponible por el momento",
  "pendingRequest": "Solicitud en curso",
  "alreadyRequestedReward": "Ya tienes una solicitud pendiente para esta recompensa",
  "pleaseLogin": "Por favor inicia sesión para solicitar recompensas",

  // Partner Offers
  "partnerOffers": "Ofertas de Socios",
  "noPartnerOffers": "No hay ofertas de socios disponibles",
  "claimOffer": "Ver",
  "requesting": "Solicitando...",
  "errorFetchingPartnerOffers": "Error al obtener ofertas de socios",
  "currentImage": "Imagen actual",
  
  // Surveys
  "surveys": "Encuestas",
  "availableSurveys": "Encuestas disponibles",
  "startSurvey": "Comenzar encuesta",
  "noSurveysAvailable": "No hay encuestas disponibles",
  "surveyCompleted": "¡Encuesta completada! Has ganado {{points}} puntos",
  "completeSurvey": "Completar encuesta",
  "nextQuestion": "Siguiente pregunta",
  "question": "Pregunta",
  "pointsWorth": "Vale",
  "completedSurveys": "Encuestas completadas",
  "noCompletedSurveys": "No hay encuestas completadas",
  "completedDate": "Fecha de finalización",
  "yes": "Sí",
  "no": "No",
  
  // Settings
  "settings": "Configuración",
  "profileSettings": "Configuración del perfil",
  "changePassword": "Cambiar contraseña",
  "updateProfile": "Actualizar perfil",
  "updatePassword": "Actualizar contraseña",
  "profileUpdated": "Perfil actualizado con éxito",
  "passwordUpdated": "Contraseña actualizada con éxito",
  "deleteAccount": "Eliminar cuenta",
  "deleteMyAccount": "Eliminar mi cuenta",
  "deleteAccountDescription": "Si desea eliminar su cuenta y todos los datos asociados, haga clic en el botón a continuación. Esta acción lo redirigirá a un formulario donde podrá enviar su solicitud de eliminación.",
  
  // Navigation
  "dashboard": "Panel",
  "notifications": "Notificaciones",
  "noNotifications": "No hay notificaciones",
  "markAllAsRead": "Marcar todo como leído",
  "markAsRead": "Marcar como leído",
  
  // Footer
  "privacyPolicy": "Política de privacidad",
  "termsOfService": "Términos de servicio",
  "legalNotice": "Aviso legal",
  "contact": "Contacto",
  "contactEmail": "contact@qonso.app",
  "allRightsReserved": "© 2025 Qonso. Todos los derechos reservados."
}